
export default {
    "system.module": "System module",
    "system.module.admin": "Admin",
    "system.module.blog": "Blog",
    "system.module.website": "Website",
    "system.module.mobile": "Mobile",
    "system.module.category": "Resource category",
    "admin.access.noright": "You do not have access rights. Please contact the administrator.",
    "admin.back.home": "Back home",
    "admin.login.title": "Login",
    "admin.login.username": "User name",
    "admin.login.username.placeholder": "Please input user name",
    "admin.login.password": "Password",
    "admin.login.password.placeholder": "Please input password",
    "admin.login.verify": "Verify code",
    "admin.login.verify.placeholder": "Please input verify code",
    "admin.login.button.submit": "Submit",
    "admin.login.error.invalid.Login_Invalid": "Invalid username or password.",
    "admin.login.error.invalid.Login_Captcha": "Invalid verify code.",
    "admin.login.error.invalid.Login_500": "Login failed",
    "admin.login.status.expired": "The session is expired. please login again.",
    "admin.layout.language.zhCN": "简体中文",
    "admin.layout.language.enGB": "English",
    "admin.layout.language": "Language",
    "admin.layout.logout": "Logout",
    "admin.layout.logo.full": "ELMSystem",
    "admin.layout.logo.abbr": "ELM",
    "admin.layout.adgroup": "Adgroup",
    "admin.layout.modal.confirm": "Confirm",
    "admin.layout.modal.cancel": "Cancel",
    "admin.layout.modal.question": "Question",
    "admin.layout.modal.logout": "Are you sure to exit the current account?",
    "admin.layout.pleaseSelect": "Please select",
    "admin.layout.placeholder.search": "Please input search text",
    "admin.layout.copyright1": "Copyright",
    "admin.layout.copyright2": ". All rights reserved.",
    "admin.layout.form.search.confirm": "Search",
    "admin.layout.form.search.clear": "Clear",
    "admin.layout.form.search.collapse": "Collapse",
    "admin.layout.input.placeholder": "Please input",
    "admin.layout.select.placeholder": "Please select",
    "admin.layout.theme": "Theme",
    "admin.layout.theme.light": "Light",
    "admin.layout.theme.dark": "Dark",
    "admin.pages.form.submit": "Submit",
    "admin.pages.form.submit.success": "Submit successfully!",
    "admin.pages.form.back": "Back",
    "admin.menu.main": "Home",
    "admin.menu.setting": "Setting",
    "admin.menu.blog": "Documents",
    "admin.pages.createUser": "Create user",
    "admin.pages.createTime": "Create time",
    "admin.pages.updateUser": "Update user",
    "admin.pages.updateTime": "Update time",
    "admin.pages.operate.delete":"Delete",
    "admin.pages.operate.edit":"Edit",
    "admin.pages.operate.add":"Add",
    "admin.pages.operate.disabled":"Disabled",
    "admin.pages.operate.enabled":"Enabled",
    "admin.pages.settings.profile": "Advanced setting",
    "admin.pages.settings.menus.general": "General",
    "admin.pages.settings.menus.account": "Account",
    "admin.pages.settings.menus.group": "Group",
    "admin.pages.settings.website.sitename": "Site name",
    "admin.pages.settings.website.description": "Description",
    "admin.pages.settings.website.adminSite.name.full": "ELMSystem",
    "admin.pages.settings.website.adminSite.name.abbr": "ELM",
    "admin.pages.settings.website.keywords": "Keywords",
    "admin.pages.settings.website.contactor": "Contactor",
    "admin.pages.settings.website.contactor.email": "Email",
    "admin.pages.settings.website.copyright": "Copyright",
    "admin.pages.menus.edit.module.admin": "Admin",
    "admin.pages.menus.edit.module.blog": "Blog",
    "admin.pages.menus.edit.module.web": "Web",
    "admin.pages.menus.edit.module.wechat": "Wechat",
    "admin.pages.menus.edit.module": "System module",
    "admin.pages.menus.edit.parent": "Parent",
    "admin.pages.menus.edit.firstLevel": "First level",
    "admin.pages.menus.edit.title": "Title",
    "admin.pages.menus.edit.icon": "Icon",
    "admin.pages.menus.edit.pathname": "Page",
    "admin.pages.menus.edit.status": "Status",
    "admin.pages.menus.edit.status.enable": "Enabled",
    "admin.pages.menus.edit.status.disable": "Disabled",
    "admin.pages.menus.edit.selectIcon": "Select an icon",
    "admin.pages.menus.list.title": "System menu list",
    "admin.pages.menus.list.id": "ID",
    "admin.pages.menus.list.name": "Name",
    "admin.pages.menus.list.pathname": "Page",
    "admin.pages.menus.list.sort": "Sort",
    "admin.pages.menus.add.title": "Add menu",
    "admin.pages.menus.delete.msg": "Are you sure to delete current menu?",
    "admin.pages.languages.type": "Language",
    "admin.pages.languages.content": "Content",
    "admin.pages.languages.all": "All",
    "admin.pages.language.name": "Field name",
    "admin.pages.language.english": "English",
    "admin.pages.language.chinese": "Chinese",
    "admin.pages.language.operate": "Operate",
    "admin.pages.language.modal.add": "Add record",
    "admin.pages.language.modal.edit": "Edit record",
    "admin.pages.language.msg.delete": "Note: After deleting the multilingual settings, the referenced places will display the Key. Simply add it again.",
    "admin.pages.user.list.name": "Login name",
    "admin.pages.user.list.nickname": "Nick name",
    "admin.pages.user.list.salt": "Salt",
    "admin.pages.user.list.smsNote": "Sms note",
    "admin.pages.user.list.status": "Status",
    "admin.pages.user.list.password.n": "New password",
    "admin.pages.user.list.password.r": "Repeat password",
    "admin.pages.user.list.msg.delete": "After deleting the account and adding it again, the name already exists. Please contact the management for processing. Are you sure to delete the current user account?",
    "admin.pages.user.group.list.name": "Group name",
    "admin.pages.user.group.list.title": "Group title",
    "admin.pages.user.group.list.module": "Module",
    "admin.pages.user.group.list.user": "Users",
    "admin.pages.user.group.list.msg.delete": "Are you sure to delete the user group?",
    "admin.pages.user.group.list.msg.sendsms": "Are you sure send message to users?",
    "admin.pages.user.group.list.sendsms": "Send sms notification",
    "admin.pages.user.group.list.smsstatus": "Last send sms status",
    "admin.pages.user.group.list.smsnote": "Last send sms note",
    "admin.pages.user.group.list.template": "Template Code",
    "admin.pages.user.group.list.note": "Note",
    "admin.pages.user.group.edit.modules": "Modules",
    "admin.pages.user.group.edit.user": "User",
    "admin.pages.user.group.edit.auth": "Authentication",
    "admin.pages.user.group.edit.item": "Item",
    "admin.pages.user.group.edit.items": "Items",
    "admin.pages.article.list.id": "Resource ID",
    "admin.pages.article.title": "Resource title",
    "admin.pages.article.category": "Category",
    "admin.pages.menus.typeTile": "Type",
    "admin.pages.article.edit.status.enable": "Published",
    "admin.pages.article.edit.status.disable": "Unpublished",
    "admin.pages.article.allCategory": "All category",
    "admin.layout.article.title.list": "Resource list",
    "admin.layout.article.title.edit": "Resource edit",
    "admin.pages.article.header": "Cover",
    "admin.pages.article.desc": "Description",
    "admin.pages.article.keywords": "Keywords",
    "admin.pages.article.download": "Allow download",
    "admin.pages.article.visits": "Visits",
    "admin.pages.article.isOriginal": "Original",
    "admin.pages.article.content": "Content",
    "admin.pages.article.download.refused": "Refused",
    "admin.pages.article.download.allow": "Allow",
    "admin.pages.article.download.limit": "Limit",
    "admin.pages.article.original.false": "Non-Original",
    "admin.pages.article.original.true": "Original",
    "admin.pages.article.formItem.required": "Required field,can not empty.",
};
